import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class WorkflowConditionService {
  private readonly conditionCatalogCache = new Map<string, Observable<any>>();
  private readonly conditionValuesCache = new Map<string, Observable<any>>();

  constructor(private readonly http: HttpClient) { }

  getAllWorkflowConditions(token, workflowID) {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    let en_URI = encodeURI(environment.apiUrl + "/workflows/" + workflowID + "/conditions");
    return this.http.get<any>(en_URI, {
      headers: httpHeaders
    });
  }

  getConditionsByAlertType(token, workflowTypeID, alertTypeID, exclude?: string) {
    const cacheKey = `${token ?? ''}|${workflowTypeID ?? ''}|${alertTypeID ?? ''}|${exclude ?? ''}`;
    const cached = this.conditionCatalogCache.get(cacheKey);
    if (cached) {
      return cached;
    }

    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });

    // Construct the query param if `exclude` is provided
    const queryString = exclude ? `?exclude=${exclude}` : '';

    const request$ = this.http.get<any>(`${environment.apiUrl}/app/workflow_types/${workflowTypeID}/workflow_conditions/${alertTypeID}${queryString}`, {
      headers: httpHeaders
    }).pipe(
      tap({ error: () => this.conditionCatalogCache.delete(cacheKey) }),
      shareReplay({ bufferSize: 1, refCount: false }),
    );

    this.conditionCatalogCache.set(cacheKey, request$);
    return request$;
  }

  getWFValuesConditionID(token, workflowTypeID, alertTypeID, conditionID) {
    const cacheKey = `${token ?? ''}|${workflowTypeID ?? ''}|${alertTypeID ?? ''}|${conditionID ?? ''}`;
    const cached = this.conditionValuesCache.get(cacheKey);
    if (cached) {
      return cached;
    }

    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    const request$ = this.http.get<any>(`${environment.apiUrl}/app/workflow_types/${workflowTypeID}/workflow_conditions/${alertTypeID}/workflow_values/${conditionID}`, {
      headers: httpHeaders
    }).pipe(
      tap({ error: () => this.conditionValuesCache.delete(cacheKey) }),
      shareReplay({ bufferSize: 1, refCount: false }),
    );

    this.conditionValuesCache.set(cacheKey, request$);
    return request$;
  }

  addWorkFlowCondition(token, workflowID, params = {}): Observable<any> {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
     let en_URI = encodeURI(environment.apiUrl + "/workflows/" + workflowID + "/conditions");
    return this.http.post<any>(en_URI, params, {
      headers: httpHeaders,
    });
  }

  updateWorkFlowCondition(token, workflowID, conditionID, params): Observable<any> {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    return this.http.put<any>(`${environment.apiUrl}/workflows/${workflowID}/conditions/${conditionID}`, params, {
      headers: httpHeaders,
    });
  }

  deleteWorkflowConditions(token, workflowID, conditionID): Observable<any> {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    return this.http.delete<any>(`${environment.apiUrl}/workflows/${workflowID}/conditions/${conditionID}`, {
      headers: httpHeaders,
    });
  }
}


